/* Mutual Optical — header search dropdown: predictive results + recent searches + popular models. No app.
 *
 * 为什么要自己做一层型号索引：Shopify 的站内搜索（含 /search/suggest.json）只做
 * **词首前缀**匹配，所以搜 "503" 命中不到型号 "ZW503"，客户必须输入较完整的名称。
 * 这里在前端补一个子串索引：拉一次 /products.json（sessionStorage 缓存 10 分钟），
 * 把标题 / 各变体 SKU / vendor 归一化成 **token 数组**，逐 token 做 indexOf 匹配，
 * 结果与 Shopify 的预测结果**合并去重**（Shopify 的排在前，因为它有相关性排序）。
 *
 * 两个刻意的取舍（都是实测踩出来的）：
 *   1. **不把各字段拼成一条再匹配**。拼接后去空格会让 "503" 跨字段边界命中
 *      （相邻两个 SKU 的尾 + 首），实测 8 个命中里有 6 个是这样来的误报。
 *   2. **不索引 handle**。本店 handle 有历史错位 —— "ZUMISA ZM504" 的 handle 是
 *      `zumisa-zm503-copy`，索引 handle 会让搜 503 命中 ZM504。handle 对客户不可见，
 *      拿它做匹配只会制造困惑。
 *
 * 只显示图片与标题，**不显示任何金额** —— 未登录访客不能看到批发价。
 * 已知限制：/products.json 不套用 BSS 的 hide-product 规则，与 Quick Order 同源问题。
 */
(function () {
  var RKEY = 'mo_recent_searches';
  function getRecent() { try { return JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) { return []; } }
  function pushRecent(q) { q = (q || '').trim(); if (!q) return; var a = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); a.unshift(q); try { localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 6))); } catch (e) {} }
  function clearRecent() { try { localStorage.removeItem(RKEY); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  /* ───────── 型号索引（客户端子串匹配） ───────── */
  var CKEY = 'mo-search-catalog-v1';
  var CTTL = 10 * 60 * 1000;
  var Cat = { list: null, loading: null };

  function norm(v) {
    return String(v == null ? '' : v).toUpperCase().replace(/[^A-Z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function loadCatalog() {
    if (Cat.list) return Promise.resolve(Cat.list);
    if (Cat.loading) return Cat.loading;
    try {
      var raw = sessionStorage.getItem(CKEY);
      if (raw) {
        var c = JSON.parse(raw);
        if (Date.now() - c.t < CTTL && c.p && c.p.length) { Cat.list = c.p; return Promise.resolve(Cat.list); }
      }
    } catch (e) {}
    Cat.loading = fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        Cat.list = (d.products || []).map(function (p) {
          var text = norm(p.title + ' ' + (p.vendor || ''));
          var toks = text ? text.split(' ') : [];
          (p.variants || []).forEach(function (v) {
            var sk = norm(v.sku);
            if (sk) toks = toks.concat(sk.split(' '));
          });
          return {
            title: p.title,
            url: '/products/' + p.handle,
            image: (p.images && p.images[0] && p.images[0].src) || '',
            text: text,
            toks: toks,
          };
        });
        try { sessionStorage.setItem(CKEY, JSON.stringify({ t: Date.now(), p: Cat.list })); } catch (e) {}
        return Cat.list;
      })
      .catch(function () { Cat.list = []; return Cat.list; });
    return Cat.loading;
  }

  /* 逐 token 子串匹配。查询里的空格去掉后再比，所以 "ZM 503" / "zm503" 都能命中 token "ZM503"；
     多词查询额外允许整句出现在 "标题 + vendor" 里（如 "youme flex"）。
     打分：token 开头命中 = 0，token 中间命中 = 1。 */
  function localMatch(q, limit) {
    var n = norm(q);
    if (!n || !Cat.list) return [];
    var needle = n.replace(/ /g, '');
    var multi = n.indexOf(' ') > -1;
    var hits = [];
    for (var i = 0; i < Cat.list.length; i++) {
      var p = Cat.list[i], best = -1;
      if (multi) {
        var at = p.text.indexOf(n);
        if (at > -1) best = at === 0 ? 0 : 1;
      }
      for (var j = 0; j < p.toks.length && best !== 0; j++) {
        var k = p.toks[j].indexOf(needle);
        if (k === 0) { best = 0; break; }
        if (k > 0 && best < 0) best = 1;
      }
      if (best < 0) continue;
      hits.push({ p: p, s: best });
    }
    hits.sort(function (a, b) { return a.s - b.s || a.p.title.localeCompare(b.p.title); });
    return hits.slice(0, limit || 12).map(function (x) { return x.p; });
  }

  var SICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg>';

  function initWrap(wrap) {
    var input = wrap.querySelector('[data-mo-search-input]');
    var panel = wrap.querySelector('[data-mo-search-panel]');
    var form = wrap.matches('form') ? wrap : wrap.querySelector('form');
    if (!input || !panel) return;
    var popular = (wrap.getAttribute('data-mo-popular') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var timer = null;

    function open() { panel.hidden = false; }
    function close() { panel.hidden = true; }

    function termItem(q) {
      return '<a class="mo-srch__term" href="/search?q=' + encodeURIComponent(q) + '&type=product">' + SICON + '<span>' + esc(q) + '</span></a>';
    }
    function group(title, itemsHtml, withClear) {
      if (!itemsHtml) return '';
      var clr = withClear ? '<button type="button" class="mo-srch__clear" data-mo-clear>Clear</button>' : '';
      return '<div class="mo-srch__group"><div class="mo-srch__hd">' + title + clr + '</div>' + itemsHtml + '</div>';
    }

    function renderEmpty() {
      var recent = getRecent();
      var html = '';
      html += group('Recent Searches', recent.map(termItem).join(''), true);
      html += group('Popular Models', popular.map(termItem).join(''), false);
      panel.innerHTML = html || '<div class="mo-srch__empty">Start typing to search the catalog…</div>';
    }

    function renderResults(products, q) {
      if (!products.length) { panel.innerHTML = '<div class="mo-srch__empty">No matches for &ldquo;' + esc(q) + '&rdquo;.</div>'; return; }
      var items = products.map(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="mo-srch__ph"></span>';
        return '<a class="mo-srch__prod" href="' + p.url + '">' + img + '<span class="mo-srch__prodt">' + esc(p.title) + '</span></a>';
      }).join('');
      panel.innerHTML = '<div class="mo-srch__group">' + items + '</div>' +
        '<a class="mo-srch__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
    }

    var reqId = 0;
    function suggest(q) {
      var mine = ++reqId;
      var remote = fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { return (d.resources && d.resources.results && d.resources.results.products) || []; })
        .catch(function () { return []; });
      var local = loadCatalog().then(function () { return localMatch(q, 8); });

      Promise.all([remote, local]).then(function (both) {
        if (mine !== reqId || panel.hidden) return;   // 已有更新的输入，丢弃这次结果
        var seen = {}, out = [];
        both[0].forEach(function (p) {
          var u = (p.url || '').split('?')[0];
          if (u && !seen[u]) { seen[u] = 1; out.push({ title: p.title, url: p.url, image: p.image }); }
        });
        both[1].forEach(function (p) {
          if (out.length >= 8 || seen[p.url]) return;
          seen[p.url] = 1; out.push(p);
        });
        renderResults(out, q);
      });
    }

    input.addEventListener('focus', function () {
      open();
      loadCatalog();                                  // 预热，第一次搜索不必等这次网络
      if (!input.value.trim()) renderEmpty();
    });
    input.addEventListener('input', function () {
      var q = input.value.trim(); open(); clearTimeout(timer);
      if (!q) { renderEmpty(); return; }
      timer = setTimeout(function () { suggest(q); }, 180);
    });
    if (form) form.addEventListener('submit', function () { pushRecent(input.value); });
    panel.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('[data-mo-clear]') : null;
      if (c) { e.preventDefault(); clearRecent(); renderEmpty(); }
      var link = e.target.closest ? e.target.closest('a') : null;
      if (link) pushRecent(input.value);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
  }

  /* 搜索结果页：Shopify 返回 0 条时，用型号索引补一批（挂载点在 main-search.liquid） */
  function initFallback() {
    var host = document.querySelector('[data-mo-search-fallback]');
    if (!host) return;
    var q = host.getAttribute('data-q') || '';
    if (!q.trim()) return;
    loadCatalog().then(function () {
      var ms = localMatch(q, 12);
      if (!ms.length) {
        // 自带的「无结果」提示在被 display:none 的容器里，这里补一个可见的，
        // 否则零结果搜索页是一片空白
        host.innerHTML =
          '<h2 class="mo-srchfb__h">No results for &ldquo;' + esc(q) + '&rdquo;</h2>' +
          '<p class="mo-srchfb__sub">Try a model number (e.g. 6102) or browse the ' +
          '<a class="mo-srchfb__link" href="/collections/all">full catalog</a>.</p>';
        host.hidden = false;
        return;
      }
      var cards = ms.map(function (p) {
        var img = p.image
          ? '<img src="' + p.image + '" alt="" loading="lazy">'
          : '<span class="mo-srchfb__ph"></span>';
        return '<a class="mo-srchfb__card" href="' + p.url + '">' + img +
          '<span class="mo-srchfb__t">' + esc(p.title) + '</span></a>';
      }).join('');
      host.innerHTML =
        '<h2 class="mo-srchfb__h">Matching models</h2>' +
        '<p class="mo-srchfb__sub">Found by model number or SKU.</p>' +
        '<div class="mo-srchfb__grid">' + cards + '</div>';
      host.hidden = false;
    });
  }

  function init() {
    var ws = document.querySelectorAll('[data-mo-searchwrap]');
    for (var i = 0; i < ws.length; i++) initWrap(ws[i]);
    initFallback();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
